import { useState } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import {
  selectFirstName,
  selectLastName,
} from "../../app-main/selectors/profile.selectors";

import { EditFieldButton } from "./EditFieldButton";
import EditNameModal from "../../app-profile/EditNameModal";
import { Text } from "@ps-design-system/components/Text";

export const ProfileName = () => {
  const firstName = useSelector(selectFirstName);
  const lastName = useSelector(selectLastName);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const name = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <>
      <div className="tw-flex tw-items-center tw-gap-40">
        <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-4">
          <Text className="tw-text-gray-900" element="p" typeface="body-2-m">
            <FormattedMessage
              id="hosting.profile_page.name_label"
              defaultMessage="Name"
            />
          </Text>
          <Text element="p" typeface="body-2">
            {name}
          </Text>
        </div>
        <div className="tw-flex tw-shrink-0 tw-items-center tw-justify-end">
          <EditFieldButton
            onClick={() => setIsEditOpen(true)}
            showEditLabel={!!name.trim()}
          />
        </div>
      </div>
      {isEditOpen && (
        <EditNameModal
          open={isEditOpen}
          onOpenChange={() => setIsEditOpen(false)}
        />
      )}
    </>
  );
};
